namespace Ir.Components.ReportDesigner.VariablesTooltip {
    export interface IVariablesTooltipParams {
        visible: KnockoutObservable<boolean> | KnockoutComputed<boolean>;
        target: KnockoutObservable<any>;
    }
    interface IViewModel {
        nameTooltipConfig: DevExpress.ui.dxTooltip.Properties;
    }

    interface IParams {
        config: IVariablesTooltipParams
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        this.nameTooltipConfig = {
            target: params.config.target as any,
            hideOnOutsideClick: false,
            visible: params.config.visible as any,
        };
    }
}